(() => {
  const SELECTOR = 'main[data-template^="product"] media-gallery img.product-media__image, main[data-template^="product"] .product-information__media img.product-media__image, main[data-template^="product"] .product-media img, .template-product media-gallery img.product-media__image, .product-information__media img';
  let modal;

  function getLargeSrc(img) {
    return img.getAttribute('data_max_resolution') || img.currentSrc || img.src;
  }

  function createModal() {
    const el = document.createElement('div');
    el.className = 'la-image-zoom-modal';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = `
      <div class="la-image-zoom-modal__backdrop" data-la-close></div>
      <div class="la-image-zoom-modal__dialog" role="dialog" aria-modal="true" aria-label="Artwork image detail view">
        <button class="la-image-zoom-modal__close" type="button" data-la-close aria-label="Close image detail view">x</button>
        <div class="la-image-zoom-modal__stage">
          <img class="la-image-zoom-modal__image" alt="">
          <div class="la-image-zoom-modal__lens" aria-hidden="true"></div>
        </div>
        <p class="la-image-zoom-modal__hint">Move your cursor over the image to inspect surface and detail.</p>
      </div>
    `;
    document.body.appendChild(el);

    el.addEventListener('click', (event) => {
      if (event.target.closest('[data-la-close]')) closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && el.classList.contains('is-open')) closeModal();
    });

    const stage = el.querySelector('.la-image-zoom-modal__stage');
    const image = el.querySelector('.la-image-zoom-modal__image');
    const lens = el.querySelector('.la-image-zoom-modal__lens');

    function moveLens(event) {
      const rect = stage.getBoundingClientRect();
      const x = Math.max(0, Math.min(event.clientX - rect.left, rect.width));
      const y = Math.max(0, Math.min(event.clientY - rect.top, rect.height));
      const xPct = rect.width ? (x / rect.width) * 100 : 50;
      const yPct = rect.height ? (y / rect.height) * 100 : 50;
      const zoom = 2.6;

      lens.style.opacity = '1';
      lens.style.left = `${x}px`;
      lens.style.top = `${y}px`;
      lens.style.backgroundImage = `url("${image.src}")`;
      lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
      lens.style.backgroundPosition = `${xPct}% ${yPct}%`;
      image.style.transformOrigin = `${xPct}% ${yPct}%`;
      image.classList.add('is-magnifying');
    }

    stage.addEventListener('pointerenter', moveLens);
    stage.addEventListener('pointermove', moveLens);
    stage.addEventListener('pointerleave', () => {
      lens.style.opacity = '0';
      image.classList.remove('is-magnifying');
    });

    return el;
  }

  function openModal(img) {
    modal = modal || createModal();
    const modalImg = modal.querySelector('.la-image-zoom-modal__image');
    modalImg.src = getLargeSrc(img);
    modalImg.alt = img.alt || 'Artwork image detail';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('la-image-zoom-open');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('la-image-zoom-open');
  }

  document.addEventListener('click', (event) => {
    const img = event.target.closest(SELECTOR);
    if (!img) return;

    const productMain = img.closest('main[data-template^="product"], .template-product, .product-information__media');
    if (!productMain) return;

    event.preventDefault();
    event.stopPropagation();
    openModal(img);
  }, true);
})();
